export type EntityType = 'transaction' | 'task' | 'contact';

export interface EntityReference {
  type: EntityType;
  id: number;
}

const NEKST_SCHEME = 'nekst://';
const VALID_ENTITY_TYPES: EntityType[] = ['transaction', 'task', 'contact'];

export function parseEntityUri(href: string | undefined): EntityReference | null {
  if (!href) {
    return null;
  }

  // Format: nekst://transaction/123, nekst://task/456, nekst://contact/789
  if (!href.startsWith(NEKST_SCHEME)) {
    return null;
  }

  const path = href.substring(NEKST_SCHEME.length);
  const parts = path.split('/');

  if (parts.length !== 2) {
    return null;
  }

  const [entityType, idString] = parts;

  if (!VALID_ENTITY_TYPES.includes(entityType as EntityType)) {
    return null;
  }

  const id = parseInt(idString, 10);
  if (isNaN(id) || id <= 0) {
    return null;
  }

  return { type: entityType as EntityType, id };
}

export function getEntityLabel(type: EntityType): string {
  switch (type) {
    case 'transaction':
      return 'transaction';
    case 'task':
      return 'task';
    case 'contact':
      return 'contact';
  }
}
